import { useAppState } from "../../../context/appStateContext"
import { usePurchase } from "../../../context/purchaseContext"
import styles from "./SpecialOfferFooter.module.scss"
import useStrings from "../../../localization/useStrings"
import PrimaryButton from "../../../components/PrimaryButton/PrimaryButton"
import Svg from "../../../utils/svg"
import OfferBox from "../../../components/OfferBox/OfferBox"
import useQueryParams from "../../../hooks/useQueryParams"
import PromoPricingInfo from "../../../models/promoPricingInfo"

const SpecialOfferFooter = () => {
  const bottomInset = useAppState().state.initialData?.bottomInset ?? 0
  const { state, actions } = usePurchase()
  const isExpiration = useQueryParams().specialOffer == "expiring"
  const strings = useStrings()

  const priceboxStrings = isExpiration
    ? strings.specialOffer.priceBoxExpiration
    : strings.specialOffer.priceBoxTrial

  const product = state.selectedPlan.yearlyProduct

  const pricinginfo = PromoPricingInfo.fromYearlyProducts(
    product,
    product,
    true
  )

  const monthlyPrice = isExpiration
    ? pricinginfo.discountedMonthlyPrice.formatted
    : pricinginfo.monthlyPrice.formatted

  const yearlyPrice = isExpiration
    ? pricinginfo.yearlyPriceDiscounted.formatted
    : pricinginfo.yearlyPriceFull.formatted

  return (
    <div className={styles.container}>
      <div className={styles.background} style={{ bottom: -bottomInset }}></div>
      <OfferEnabled />
      <div className={styles.offerBoxContainer}>
        <OfferBox
          title={priceboxStrings.title}
          offerName={priceboxStrings.offerName}
          bottomRightSubtitle={strings.monthlyPrice(monthlyPrice)}
          subtitleComponent={
            <>
              {strings.premiumToUltimateBlackFriday.monthPrefix + " "}
              {yearlyPrice}
            </>
          }
        />
      </div>
      <div className={styles.ctaContainer}>
        <PrimaryButton onClick={() => actions.purchaseCurrentOffer()}>
          {priceboxStrings.ctaTitle}
        </PrimaryButton>
      </div>
    </div>
  )
}

const OfferEnabled = () => {
  const strings = useStrings().specialOffer

  const root = document.documentElement
  const primaryColor = getComputedStyle(root)
    .getPropertyValue("--color-primary")
    .trim()

  return (
    <div className={styles.offerContainer}>
      <label className={styles.offerTitle}>{strings.enabledTitle}</label>
      <Svg.CheckmarkCircle fill={primaryColor} />
    </div>
  )
}

export default SpecialOfferFooter
